export type MenuItem = {
  label: string;
  href?: string;
  isLarge?: boolean;
  tag?: string;
};

export type MegamenuTile = {
  label: string;
  href?: string;
  icon: string;
  tag?: string;
  isActive?: boolean;
};

export const megamenuTiles: MegamenuTile[] = [
  {
    label: "Chcem nové číslo",
    icon: "sim",
    tag: "1 mesiac zadarmo",
    isActive: true,
  },
  {
    label: "Chcem preniesť číslo",
    icon: "showroom-mobile-pro",
    tag: "1 mesiac zadarmo",
  },
  { label: "Chcem zmeniť paušál", icon: "showroom-mobile-pro" },
];

type MenuGroup = {
  id: string;
  heading: string;
  items: MenuItem[];
};

export type MenuSection = {
  id: string;
  label: string;
  featured: MenuGroup;
  columns: MenuGroup[][];
};

export const menuSections: MenuSection[] = [
  {
    id: "volania",
    label: "Volania",
    featured: {
      id: "odporucane-sluzby",
      heading: "Odporúčané služby",
      items: [
        { label: "Super paušály", isLarge: true },
        { label: "Predplatené karty", isLarge: true },
        { label: "Roaming", isLarge: true },
        { label: "Love", isLarge: true },
      ],
    },
    columns: [
      [
        {
          id: "pausaly",
          heading: "Paušály",
          items: [
            { label: "Prehľad paušálov" },
            { label: "Super paušály", tag: "Novinka" },
            { label: "Yoxo paušál" },
            { label: "Paušalík" },
          ],
        },
        {
          id: "s-kreditom",
          heading: "Volania s kreditom",
          items: [
            { label: "Prima Voľba" },
            { label: "Prima Kids" },
            { label: "FunFón" },
          ],
        },
      ],
      [
        {
          id: "zahranicie",
          heading: "Zahraničie",
          items: [
            { label: "Roaming" },
            { label: "Roamingové balíky" },
            { label: "Volania do zahraničia" },
            { label: "Regulovaný roaming v EÚ" },
            { label: "Cestovné poistenie" },
          ],
        },
        {
          id: "doplnkove-sluzby",
          heading: "Doplnkové služby",
          items: [
            { label: "eWatch", tag: "Novinka" },
            { label: "eSIM" },
            { label: "Poistenie zariadení" },
          ],
        },
      ],
      [
        {
          id: "nase-sluzby",
          heading: "Ste náš zákazník?",
          items: [
            { label: "Chcem zmeniť paušál" },
            { label: "Chcem predĺžiť služby" },
            { label: "Dobiť kredit" },
            { label: "Odporučte Orange" },
            { label: "Navzájom zadarmo" },
          ],
        },
      ],
    ],
  },
  {
    id: "internet-tv",
    label: "Internet, TV",
    featured: {
      id: "odporucane-sluzby",
      heading: "Odporúčané služby",
      items: [
        { label: "Internet na doma", isLarge: true },
        { label: "Mobilný internet", isLarge: true },
        { label: "Televízia", isLarge: true },
        { label: "Internet + TV", isLarge: true },
      ],
    },
    columns: [
      [
        {
          id: "pausaly",
          heading: "Internet",
          items: [
            { label: "Prehľad internetu" },
            { label: "Mobilný internet" },
            { label: "Bezpečný internet so sebou" },
            { label: "Domáca linka k internetu" },
          ],
        },
      ],
      [
        {
          id: "televizia",
          heading: "Televízia",
          items: [
            { label: "Najlepšia TV na doma" },
            { label: "TV cez satelit" },
            { label: "TV cez internet" },
            { label: "Novinky na Orange TV" },
          ],
        },
      ],
      [
        {
          id: "internet-televizia",
          heading: "Internet + televízia",
          items: [
            { label: "Ponuka Love" },
            { label: "Výhodný pár zariadení" },
            { label: "Volania do zahraničia" },
            { label: "Regulovaný roaming" },
          ],
        },
        {
          id: "nase-sluzby",
          heading: "Ste náš zákazník?",
          items: [
            { label: "Predĺžiť služby" },
            { label: "Nový internet" },
            { label: "Nová televízia" },
            { label: "Odporučte Orange" },
          ],
        },
      ],
    ],
  },
  {
    id: "telefony-zariadenia",
    label: "Telefóny a zariadenia",
    featured: {
      id: "odporucane-sluzby",
      heading: "Odporúčané služby",
      items: [
        { label: "iPhone 15", isLarge: true },
        { label: "iPhone 15 Pro", isLarge: true },
        { label: "Samsung Z Fold", isLarge: true },
        { label: "Motorola", isLarge: true },
        { label: "Oppo", isLarge: true },
      ],
    },
    columns: [
      [
        {
          id: "telefony",
          heading: "Telefóny",
          items: [
            { label: "Apple" },
            { label: "Samsung" },
            { label: "Huawei" },
            { label: "Honor" },
            { label: "Motorola" },
            { label: "Oppo" },
          ],
        },
      ],
      [
        {
          id: "tablety-a-notebooky",
          heading: "Tablety a notebooky",
          items: [
            { label: "Lenovo" },
            { label: "Samsung" },
            { label: "Honor" },
            { label: "Apple" },
            { label: "Asus" },
          ],
        },
      ],
      [
        {
          id: "sikovne-zariadenia",
          heading: "Šikovné zariadenia",
          items: [
            { label: "Smart hodinky" },
            { label: "Smart domácnosť" },
            { label: "Smart TV" },
            { label: "Herné konzoly" },
          ],
        },
        {
          id: "orange-akcie",
          heading: "Orange akcie",
          items: [
            { label: "Samsung" },
            { label: "Výhodné ponuky" },
            { label: "Zľavy na telefóny" },
            { label: "Dopredaj zariadení" },
          ],
        },
      ],
    ],
  },
];

export const searchTerms = [
  "Dobitie kreditu",
  "Nedostupnosť služieb",
  "Faktúry",
  "Zdieľanie dát",
  "Prečerpané dáta",
  "Elektronická faktúra",
  "Prvá pomoc internet",
  "Nastavenie zariadení a sim kariet",
  "Pevny internet do domacnosti",
  "Dátový roaming",
  "Nákup online",
  "Telemarketing",
];

export const searchResultItems = [
  "apple",
  "apple hodinky",
  "apple iphone",
  "apple 16",
  "apple pro",
  "apple watch",
];
